//#region Libraries
//#endregion
//#region Styles
import { 
    Container,
    TDef } from "components/CustomTableList/components/TableListItem/ListItem/styles";
//#endregion
//#region Components
//#endregion
//#region Icons
import { 
    Cell, NameCell, 
    CategoryCell, RoleCell,
    UserCell, DateTimeCell } from "./styles";
//#endregion
//#region Utils
//#endregion

const TDEF_CONTENT_PROPS = {
    margin: "1px 0"
};

const TableListItem = ({
    user,
    name,
    surname,
    category,
    role,
    date,
    time,
    changes
}) => {
    //#region Functions
    const getClassName = {
        cell: fieldIsChanged => {
            const classList = ["small", "ellipsis"];
            fieldIsChanged && classList.push("changed");
            return classList.join(" ");
        },
        actionsCell: () => {
            const classList = ["small"];
            return classList.join(" ");
        }
    };
    const getPropsForCell = fieldIsChanged => {
        return {
            ...TDEF_CONTENT_PROPS,
            className: getClassName.cell(fieldIsChanged)
        };  
    }
    //#endregion
    return (
        <Container>
            <TDef>
                <UserCell {...getPropsForCell()}>
                    <h5 title={user}>{user}</h5>
                </UserCell>
            </TDef>
            <TDef>
                <NameCell {...getPropsForCell(changes.name)}>
                    <h5 title={name}>{name}</h5>
                </NameCell>
            </TDef>
            <TDef>
                <NameCell {...getPropsForCell(changes.surname)}>
                    <h5 title={surname}>{surname}</h5>
                </NameCell>
            </TDef>
            <TDef>
                <CategoryCell {...getPropsForCell(changes.category)}>
                    <h5 title={category}>{category}</h5>
                </CategoryCell>
            </TDef>
            <TDef>
                <RoleCell {...getPropsForCell(changes.role)}>
                    <h5 title={role}>{role}</h5>
                </RoleCell>
            </TDef>
            <TDef>
                <DateTimeCell {...getPropsForCell()}>
                    <h5 title={date}>{date}</h5>
                </DateTimeCell>
            </TDef>
            <TDef>
                <DateTimeCell {...getPropsForCell()}>
                    <h5 title={time}>{time}</h5>
                </DateTimeCell>
            </TDef>
        </Container>
    );
}

export default TableListItem;